var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPieChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M13 2.05V11h8.949c-.47-4.717-4.232-8.48-8.949-8.95m4.969 17.954c2.189-1.637 3.694-4.14 3.98-7.004h-8.183z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M11 12V2.05C5.954 2.556 2 6.825 2 12c0 5.514 4.486 10 10 10a9.9 9.9 0 0 0 4.255-.964s-5.253-8.915-5.254-9.031z"
})));
export default SvgPieChart;